module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid1_800x693.05f20f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid1_800x693.jpg
// module id = Bf9T
// module chunks = 0